var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0C4.93743 0 4.48148 0.45595 4.48148 1.01852V4.48148H1.01852C0.45595 4.48148 0 4.93743 0 5.5C0 6.06257 0.45595 6.51852 1.01852 6.51852H4.48148V9.98148C4.48148 10.5441 4.93743 11 5.5 11C6.06257 11 6.51852 10.5441 6.51852 9.98148V6.51852H9.98148C10.5441 6.51852 11 6.06257 11 5.5C11 4.93743 10.5441 4.48148 9.98148 4.48148H6.51852V1.01852C6.51852 0.45595 6.06257 0 5.5 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.22c19a10.svg";
export { ForwardRef as ReactComponent };